/**
 * Pricing Table — editor component.
 *
 * The chooser is a child block now, so nothing is drawn here but the grid. What
 * the canvas shows is exactly what the front end will: the same radios, and the
 * same `:has()` rules switching the prices behind them. Clicking an option on
 * the canvas therefore previews it for real, which is why the block no longer
 * carries a preview state or an editor-only copy of the toggle.
 */
import {
  useBlockProps,
  useInnerBlocksProps,
  InspectorControls,
} from '@wordpress/block-editor';

import TableSettings from './TableSettings';
import { PRICING_TABLE_TEMPLATE } from '../../_shared/pricing-defaults';
import { getBlockGapValue } from '../../../utils/helpers';
import '../editor.scss';

export default function Edit({ attributes, setAttributes }) {
  const { style } = attributes;

  /*
   * Core's Block spacing value, applied here because core itself only writes
   * blockGap through the layout support — which this block does not declare.
   * The same helper render.php uses, so the axis pick and the length check
   * cannot drift between the editor and the front end.
   */
  const gap = getBlockGapValue(style?.spacing?.blockGap);

  const blockProps = useBlockProps({
    className: 'brandy-pricing-table',
    // Left unset when empty so the stylesheet's fallback chain decides, the
    // same way render.php omits the property.
    style: gap ? { '--pricing-gap': gap } : undefined,
  });

  const innerBlocksProps = useInnerBlocksProps(
    { className: 'brandy-pricing-table__inner' },
    {
      // Group and Columns are allowed so the plans can be arranged by a block
      // that already has layout controls, instead of by a column count here.
      allowedBlocks: [
        'brandy/pricing-plan',
        'brandy/pricing-options',
        'core/group',
        'core/columns',
      ],
      template: PRICING_TABLE_TEMPLATE,
    }
  );

  return (
    <>
      <InspectorControls>
        <TableSettings attributes={attributes} setAttributes={setAttributes} />
      </InspectorControls>

      <div {...blockProps}>
        <div {...innerBlocksProps} />
      </div>
    </>
  );
}
